/**
 * @generated SignedSource<<0f030f0aa7fc7127e89f8dbe2d31cac6>>
 * @relayHash 19f89c054b390c8cf55ca76111db1a16
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/576.0.0-2026-09-10T13:50:28.261Z/PhotosSearchBrowseFirmDetailsRendererQuery

import { ConcreteRequest } from 'relay-runtime';
export type PhotosSearchBrowseFirmDetailsRendererQuery$variables = {
  firmId: number;
};
export type PhotosSearchBrowseFirmDetailsRendererQuery$data = {
  readonly viewer: {
    readonly tradeFirm: {
      readonly publicProfile: {
        readonly profilePhoto: string | null;
      } | null;
    } | null;
  };
};
export type PhotosSearchBrowseFirmDetailsRendererQuery = {
  response: PhotosSearchBrowseFirmDetailsRendererQuery$data;
  variables: PhotosSearchBrowseFirmDetailsRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "firmId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "firmId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePhoto",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhotosSearchBrowseFirmDetailsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PhotosSearchBrowseFirmDetailsRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/576.0.0-2026-09-10T13:50:28.261Z/PhotosSearchBrowseFirmDetailsRendererQuery",
    "metadata": {},
    "name": "PhotosSearchBrowseFirmDetailsRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a0e4a74a9e07c6d1da1fcf4ef1b70562";

export default node;
